module.exports = __webpack_public_path__ + "img/Ele5.5c84382d.jpg";